import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

export const EnterpriseOrgScopedPageExtras = ({ children }: Props) => {
  return (
    <React.Fragment>
      <main>{children}</main>
    </React.Fragment>
  );
};
